module.exports = __webpack_public_path__ + "static/online-brown-93bba4864bdd23c70a5ff52737ddc65d.svg";